import React from 'react';
import { Button } from 'semantic-ui-react';
import FilterToggleButtons from './FilterToggleButtons';

const FilterToggles = ({ filters, children }) => (
  <Button.Group icon compact size="small">
    <FilterToggleButtons filters={filters} />
    {children}
  </Button.Group>
);

export default FilterToggles;
